import { openCloseToast, doFindCompanies } from "../../../../Global/actions";
import { getAssignedCompanies, getAllCompanies, assignCompany, deleteCompany, assignCompanyAV2, deleteCompanyAV2 } from "../../../../../services/ContactCenterApi";
import { getUserFunctionalities } from "../../../../Acceso/Login/actions";
import { validarRutsEmpresas } from "services/EmpresasAutoasignadasApi";
import { isIframe } from "helpers/isIframe";

export const loading = (isLoading) => ({
  type: "LOADING_AUTOASIGNACIONES",
  isLoading,
});

export const setContactCenter = (companies) => ({
  type: "SET_EMPRESAS_ACHS",
  companies,
});

export const updateAssignedCompanies = (update) => ({
  type: "UPDATE_ASSIGNED_COMPANIES",
  update,
});

export const updateAllCompanies = (update) => ({
  type: "UPDATE_ALL_COMPANIES",
  update,
});

export const setAllCompanies = (companies) => ({
  type: "SET_ALL_COMPANIES",
  companies,
});

export const openCloseModalAgregar = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_AGREGAR_EMPRESAS",
  isOpen,
});

export const openCloseModalEliminarEmpresa = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_EMPRESA",
  isOpen,
});

export const setSelectedCompanies = (companies) => ({
  type: "SET_SELECTED_COMPANIES",
  companies,
});

export const doGetContactCenter = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getAssignedCompanies();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setContactCenter(result.SelfAssignments));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetAllCompanies = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getAllCompanies();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setAllCompanies(result.Companies));
    }
  } catch (e) {
    console.error(e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doDeleteCompanies = (userRut, companies, closeModalCallback) => async (dispatch) => {
  dispatch(loading(true));
  localStorage.setItem('reload', 'false')
  let responses = []
  try {
    const items = companies.map((c) => ({
      UserRolId: c.UserRolId,
      CompanyRut: c.CompanyRut,
    }));
    if(isIframe){ // if it is an iframe
      const response_av2 = await deleteCompanyAV2(items.map(r => r.CompanyRut))
      responses.push(response_av2)

      if(response_av2.status === 200){
        const response_av1 = await deleteCompany(items)
        responses.push(response_av1)
      }
    }else{
      const response = await deleteCompany(items)
      responses.push(response)
    }
    if (!responses.filter(r => r.status !== 200).length) {
      localStorage.setItem('reload', 'true')
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Se han eliminado las empresas con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
      closeModalCallback();
      dispatch(doFindCompanies(userRut));
      dispatch(updateAllCompanies(true));
      dispatch(updateAssignedCompanies(true));
    }else{
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Ha ocurrido un error al eliminar la(s) empresa(s)",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doAddCompanies = (userRut, companies, closeModalCallback) => async (dispatch) => {
  dispatch(loading(true));
  localStorage.setItem('reload', 'false')
  let responses = []
  try {
    const ruts = companies.map((c) => c.CompanyRut);
    if(isIframe){ // if it is an iframe
      const { rutsValidos, rutsNoValidos } = await validarRutsEmpresas(ruts)
      if(rutsValidos.length){
        let response_av2 = await assignCompanyAV2(rutsValidos)
        response_av2 = await response_av2.json()
        responses.push(response_av2)
        localStorage.setItem('selfAssignedEnterprise', 'true')
        if(rutsNoValidos.length){
          responses.push({rutsNoValidos, status: 'NoValid'})
        }
      }else{
        responses.push({rutsNoValidos, status: 'NoValid'})
      }
    }else{
      const response = await assignCompany(ruts)
      responses.push(response)
    }
    
    if (!responses.filter(r => r.status !== 200).length) {
      localStorage.setItem('reload', 'true')
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Se han agregado las empresas con éxito",
        typeStyle: "success",
        displayTime: 5000
      }));
      closeModalCallback();
      dispatch(getUserFunctionalities(userRut));
      dispatch(doFindCompanies(userRut));
      dispatch(updateAllCompanies(true));
      dispatch(updateAssignedCompanies(true));
    }else{
      const responseWithError = responses.find(r => r.status === 'NoValid')
      if(responseWithError && responseWithError.rutsNoValidos){
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: `Las siguientes empresas no han sido autoasignadas: ${responseWithError.rutsNoValidos.join(',')}. Comuníquese con el administrador. `,
          typeStyle: "error",
          displayTime: 5000
        }));
        closeModalCallback();
        dispatch(getUserFunctionalities(userRut));
        dispatch(doFindCompanies(userRut));
        dispatch(updateAllCompanies(true));
        dispatch(updateAssignedCompanies(true));
      }else{
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: "Ha ocurrido un error al autoasignar la(s) empresa(s)",
          typeStyle: "error",
          displayTime: 5000
        }));
      }
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};
